import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Stack } from '@hub/stack';
import { Box } from '@hub/box';
import { jsx as _jsx } from "react/jsx-runtime";
const Tile = _ref => {
  let {
    isLastChild = false,
    children,
    asOuter,
    asInner,
    onClick,
    sxOuter,
    sxInner
  } = _ref;
  return /*#__PURE__*/_jsx(Box, {
    as: asOuter,
    sx: _objectSpread({
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: ['surfaceBrandPrimary', 'surfaceBrandPrimary', 'transparent', 'transparent'],
      borderRightWidth: isLastChild ? 'none' : ['0px', '0px', '1px '],
      borderRightStyle: isLastChild ? 'none' : 'solid',
      borderRightColor: isLastChild ? 'transparent' : ['transparent', 'transparent', 'ghost', 'ghost'],
      ['@media screen and (max-width: 310px)']: {
        fontSize: 'font-sm'
      },
      ['@media screen and (max-width: 280px)']: {
        letterSpacing: '-0.5px'
      }
    }, sxOuter),
    onClick: onClick,
    buttonVariant: "tile",
    "data-id": "tile-list_tile_Tile_Box",
    children: /*#__PURE__*/_jsx(Stack, {
      align: "center",
      justify: "center",
      sx: _objectSpread({
        paddingY: 'spacing-md',
        minWidth: '132px'
      }, sxInner),
      as: asInner,
      "data-id": "tile-list_tile_Tile_Box_Stack",
      children: children
    })
  });
};
export default Tile;